<template>
  <CustomSelect
    class="select-width-125"
    :model-value="currentLocale"
    @update:model-value="onI18nChange"
    :options="i18nOptions"
    :placeholder="$t('language.select_language')"
  />
</template>

<script>
import passConstants from "@/constants/passConstants"
import CustomSelect from "@/v3components/shared/Form/CustomSelect.vue"
import { computed, onMounted } from "vue"
import { useI18n } from "vue-i18n"
import { useStore } from "vuex"

export default {
  name: "KioskLocaleSelector",
  components: {
    CustomSelect
  },
  setup() {
    const store = useStore()
    const { locale } = useI18n({ useScope: "global" })

    const currentLocale = computed(() => {
      const optionLocale = i18nOptions.value.find(
        (option) => option.value === locale.value
      )
      return optionLocale
        ? optionLocale
        : {
            label: "English",
            value: "en"
          }
    })

    const i18nOptions = computed(() => {
      return passConstants.PASS_APP_LOCALE_OPTIONS.options
    })

    const setI18nLocale = (localeValue) => {
      localStorage.setItem(
        passConstants.LOCAL_STORAGE_KEYS.LOCALE_TYPE,
        localeValue
      )
      locale.value = localeValue
      store.commit("authentication/SET_LOCALE", localeValue)
    }

    const onI18nChange = (value) => {
      const locale =
        typeof value === "object" && value?.value ? value.value : value
      setI18nLocale(locale)
    }

    onMounted(() => {
      // For kiosk mode, always check localStorage first, then fallback to default
      const localeTypeSaved = localStorage.getItem(
        passConstants.LOCAL_STORAGE_KEYS.LOCALE_TYPE
      )
      if (localeTypeSaved) {
        setI18nLocale(localeTypeSaved)
      } else {
        setI18nLocale(passConstants.DEFAULT_LOCALE_LANGUAGE)
      }
    })

    return {
      currentLocale,
      onI18nChange,
      i18nOptions
    }
  }
}
</script>

<style scoped>
.select-width-125 {
  min-width: 125px;
}
</style>
